module.exports = __webpack_public_path__ + "img/40_38_051_950.92d63f00.jpg";